<template>
    <section class="step-card d-flex flex-column">
      <div class="step-card-header d-flex flex-row align-items-center">
        <span class="step-card-number">1</span>
        <div>
          <h3>{{$t('solutionGui.header')}}</h3>
          <p v-html="$t('solutionGui.description')"></p>
        </div>
      </div>
        <div class="step-card-items d-grid justify-content-center">
            <div class="step-card-item"  v-for="(system) in systemSolutions" :key="'mobile'+system.id">
            <system-card  @selectCard="selectSystemCard"  :system="system" />
            </div>
        </div>
    </section>
</template>



<script>
import SystemCard from '../System/SystemCard.vue';
export default {
  components: { SystemCard },
    name: "SystemSelect",
    emits: ['onSelectedChange'],
    data() {
        return {
            
                }
    },
    methods: {
        selectSystemCard(systemCard) {
            let element = this.systemSolutions.find(obj => obj.id == systemCard.id)
            //const valueBefore = false // Toggle Funktion ist deaktiviert
            this.systemSolutions.map((card => card.active = false));
/*             
            if(valueBefore === true){
                element.active = false
            } else {
                element.active = true
            } */
            element.active = true
            element = this.systemSolutions.find(obj => obj.active === true)
            this.$emit('onSelectedChange', element)
        }
    },
    computed: {
    },
    props: {
        systemSolutions: Object
    }
}
</script>

<style lang="scss" scoped>
.step-card-items {
  grid-template-columns: repeat(1, 1fr);
  grid-auto-rows: 1fr;
  gap: var(--beg-gap);

  @media (min-width: 600px) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media (min-width: 1024px) {
    grid-template-columns: repeat(5, 1fr);
  }

  .step-card-item a:hover {
    background-color: var(--color-transparent-grey-25);
  }
}

    .row {
        --bs-gutter-x: 1.5rem;
        --bs-gutter-y: 0;
        display: flex;
        flex-wrap: wrap;
        margin-top: calc(var(--bs-gutter-y)*-1);
        margin-right: calc(var(--bs-gutter-x)*-.5);
        margin-left: calc(var(--bs-gutter-x)*-.5);
    }

    .searchBar {
        width: 100% !important; 
        @media (min-width: 576px) { 
            width: 50%  !important;
        }
        @media (min-width: 768px) { 
            width: 50%  !important;
        }
        @media (min-width: 992px) { 
            width: 40%  !important;
         }
         @media (min-width: 1200px) { 
            width: 25%  !important;
        }

    }

 

</style>